module.exports = __webpack_public_path__ + "img/facebook-messenger.0bb7ea5e.svg";